// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ul[data-v-aa6401d4]{font-weight:700;padding-left:20px}", "",{"version":3,"sources":["webpack://./resources/assets/ts/Accounts/XeroSyncErrorAlert.vue"],"names":[],"mappings":"AACA,oBAAyB,eAAA,CAApB,iBAEL","sourcesContent":["\nul { padding-left: 20px; font-weight: bold; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
